import React from 'react'
import { OTPInput, SlotProps, OTPInputProps } from 'input-otp'
import { cn } from '@global/utils/tailwind'

type OtpInputProps = Partial<OTPInputProps> & {
  inputRef?: React.Ref<HTMLInputElement>
}

export const OtpInput = ({
  onComplete,
  onChange,
  value,
  maxLength = 6,
  name,
  inputRef,
}: OtpInputProps) => {
  return (
    <OTPInput
      maxLength={maxLength}
      containerClassName="group flex items-center has-[:disabled]:opacity-30"
      onChange={onChange}
      onComplete={onComplete}
      value={value}
      name={name}
      ref={inputRef}
      render={({ slots }) => (
        <>
          <div className="flex">
            {slots.slice(0, 3).map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>

          <FakeDash />

          <div className="flex">
            {slots.slice(3).map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>
        </>
      )}
    />
  )
}

function Slot(props: SlotProps) {
  return (
    <div
      className={cn(
        'relative w-10 h-14 text-[2rem]',
        'flex items-center justify-center',
        'transition-all duration-300',
        'border-cv-blue-300 border-y border-r first:border-l first:rounded-l-md last:rounded-r-md',
        'group-hover:border-cv-blue-600 group-focus-within:border-cv-blue-400',
        'outline outline-0 outline-cv-blue-400',
        { 'outline-2 outline-cv-blue-600': props.isActive },
      )}
    >
      {props.char !== null && <div>{props.char}</div>}
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  )
}

function FakeCaret() {
  return (
    <div className="absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink">
      <div className="w-px h-8 bg-cv-blue-300" />
    </div>
  )
}

function FakeDash() {
  return (
    <div className="flex w-10 justify-center items-center">
      <div className="w-3 h-1 rounded-full bg-cv-blue-300" />
    </div>
  )
}
